module.exports = __webpack_public_path__ + "img/searchno.c2f469fc.png";